document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------- Quantity +/- buttons ---------- */
  var initQuantityWrappers = function (root) {
    (root || document).querySelectorAll('[data-quantity-wrapper]').forEach(function (wrapper) {
      if (wrapper.hasAttribute('data-quantity-bound')) return;
      wrapper.setAttribute('data-quantity-bound', '');
      var input = wrapper.querySelector('input[type="number"]');
      var minus = wrapper.querySelector('[data-quantity-minus]');
      var plus = wrapper.querySelector('[data-quantity-plus]');
      if (!input) return;
      var notifyChange = function () {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      minus && minus.addEventListener('click', function () {
        var min = parseInt(input.min || '1', 10);
        var value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
        input.value = value;
        notifyChange();
      });
      plus && plus.addEventListener('click', function () {
        var value = (parseInt(input.value, 10) || 0) + 1;
        input.value = value;
        notifyChange();
      });
      input.addEventListener('change', function () {
        var min = parseInt(input.min || '1', 10);
        if (input.value === '' || parseInt(input.value, 10) < min) {
          input.value = min;
        }
      });
    });
  };
  initQuantityWrappers(document);

  /* ---------- Money formatting (uses the shop's money format) ---------- */
  var formatNumber = function (cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  };
  var makeMoneyFormatter = function (rawFormat) {
    var decoder = document.createElement('textarea');
    decoder.innerHTML = (rawFormat || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    var moneyFormat = decoder.value;
    return function (cents) {
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals': value = formatNumber(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = formatNumber(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatNumber(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = formatNumber(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = formatNumber(cents, 2, ' ', ','); break;
        default: value = formatNumber(cents, 2, ',', '.');
      }
      return match ? moneyFormat.replace(match[0], value) : value;
    };
  };

  /* ---------- Product price: follows quantity and variant ---------- */
  var variantDataEl = document.querySelector('[data-product-variants]');
  var productData = null;
  if (variantDataEl) {
    try { productData = JSON.parse(variantDataEl.textContent); } catch (e) { productData = null; }
  }
  if (productData && productData.variants && productData.variants.length) {
    var qtyInput = document.getElementById('ProductQuantity');
    var variantSelect = document.querySelector('[data-variant-select]');
    var variantIdInput = document.querySelector('[data-variant-id]');
    var priceCurrent = document.querySelector('[data-price-current]');
    var priceCompare = document.querySelector('[data-price-compare]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyId = document.querySelector('[data-sticky-variant-id]');
    var stickyQty = document.querySelector('[data-sticky-quantity]');
    var stickyAdd = document.querySelector('[data-sticky-add]');
    var formatMoney = makeMoneyFormatter(productData.money_format);

    var getCurrentVariant = function () {
      var id = variantSelect ? variantSelect.value : (variantIdInput ? variantIdInput.value : null);
      for (var i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === String(id)) return productData.variants[i];
      }
      return productData.variants[0];
    };

    var updateProductPrice = function () {
      var variant = getCurrentVariant();
      var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
      var total = variant.price * qty;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (priceCurrent) {
        priceCurrent.textContent = formatMoney(total);
        priceCurrent.classList.toggle('product-page__price-sale', !!onSale);
      }
      if (priceCompare) {
        priceCompare.hidden = !onSale;
        priceCompare.textContent = onSale ? formatMoney(variant.compare_at_price * qty) : '';
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(total);
      if (stickyId) stickyId.value = variant.id;
      if (stickyQty) stickyQty.value = qty;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
    };

    if (qtyInput) {
      qtyInput.addEventListener('input', updateProductPrice);
      qtyInput.addEventListener('change', updateProductPrice);
    }
    if (variantSelect) variantSelect.addEventListener('change', updateProductPrice);
    updateProductPrice();
  }

  /* ---------- Cart page: update totals automatically when quantities change ---------- */
  var cartPage = document.querySelector('[data-cart-page]');
  if (cartPage && window.fetch) {
    var cartSectionId = cartPage.getAttribute('data-section-id');
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartTimer = null;
    var cartBusy = false;
    var cartQueued = false;

    var updateHeaderCount = function (count) {
      var cartLink = document.querySelector('.site-header__cart');
      if (!cartLink) return;
      var badge = cartLink.querySelector('.site-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          cartLink.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
    };

    var fallbackSubmit = function () {
      var form = cartPage.querySelector('form');
      if (form) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'update';
        hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      } else {
        window.location.reload();
      }
    };

    var syncCart = function () {
      if (cartBusy) { cartQueued = true; return; }
      var inputs = cartPage.querySelectorAll('[data-cart-qty]');
      if (!inputs.length) return;
      var updates = [];
      inputs.forEach(function (input) {
        updates.push(Math.max(0, parseInt(input.value, 10) || 0));
      });
      cartBusy = true;
      cartPage.style.transition = 'opacity .2s';
      cartPage.style.opacity = '0.6';

      fetch(shopRoot + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart update failed');
          return res.json();
        })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return fetch(shopRoot + 'cart?section_id=' + encodeURIComponent(cartSectionId));
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart render failed');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-page]');
          if (!fresh) throw new Error('cart section missing');
          cartPage.innerHTML = fresh.innerHTML;
          cartPage.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
          initQuantityWrappers(cartPage);
        })
        .catch(function () {
          fallbackSubmit();
        })
        .then(function () {
          cartBusy = false;
          cartPage.style.opacity = '';
          if (cartQueued) {
            cartQueued = false;
            syncCart();
          }
        });
    };

    var scheduleCartSync = function (delay) {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(syncCart, delay);
    };

    cartPage.addEventListener('change', function (event) {
      if (event.target && event.target.hasAttribute('data-cart-qty')) scheduleCartSync(300);
    });
    cartPage.addEventListener('input', function (event) {
      if (event.target && event.target.hasAttribute('data-cart-qty') && event.target.value !== '') scheduleCartSync(700);
    });
  }

  /* ---------- Reveal-on-scroll animation ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- Journal search + sort ---------- */
  var journalGrid = document.querySelector('[data-journal-grid]');
  if (journalGrid) {
    var journalSearch = document.querySelector('[data-journal-search]');
    var journalSort = document.querySelector('[data-journal-sort]');
    var journalNoResults = document.querySelector('[data-journal-no-results]');
    var journalCards = Array.prototype.slice.call(journalGrid.querySelectorAll('[data-journal-card]'));

    var applyJournalFilter = function () {
      var query = journalSearch ? journalSearch.value.trim().toLowerCase() : '';
      var visibleCount = 0;
      journalCards.forEach(function (card) {
        var title = (card.getAttribute('data-title') || '').toLowerCase();
        var isMatch = !query || title.indexOf(query) !== -1;
        card.style.display = isMatch ? '' : 'none';
        if (isMatch) visibleCount += 1;
      });
      if (journalNoResults) journalNoResults.hidden = visibleCount !== 0;
    };

    var applyJournalSort = function () {
      var value = journalSort ? journalSort.value : 'newest';
      var sorted = journalCards.slice();
      if (value === 'az') {
        sorted.sort(function (a, b) {
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        });
      } else {
        /* "popular" and "most-read" fall back to newest-first: Shopify
           themes have no built-in article view-count data source. */
        sorted.sort(function (a, b) {
          return parseInt(b.getAttribute('data-date'), 10) - parseInt(a.getAttribute('data-date'), 10);
        });
      }
      sorted.forEach(function (card) { journalGrid.appendChild(card); });
    };

    if (journalSearch) journalSearch.addEventListener('input', applyJournalFilter);
    if (journalSort) journalSort.addEventListener('change', applyJournalSort);
  }

  /* ---------- Article sticky table of contents ---------- */
  var tocList = document.querySelector('[data-toc-list]');
  var articleBody = document.querySelector('[data-article-body]');
  var tocWrap = document.querySelector('[data-article-toc]');
  if (tocList && articleBody && tocWrap) {
    var headings = articleBody.querySelectorAll('h2, h3');
    if (headings.length >= 2) {
      headings.forEach(function (heading, index) {
        if (!heading.id) heading.id = 'toc-heading-' + index;
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        if (heading.tagName === 'H3') link.className = 'article-toc__sub';
        tocList.appendChild(link);
      });
    } else {
      tocWrap.style.display = 'none';
    }
  }

  /* ---------- Subtle parallax on hero images ---------- */
  var parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length) {
    var onParallaxScroll = function () {
      parallaxEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var offset = rect.top * 0.1;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    };
    window.addEventListener('scroll', onParallaxScroll, { passive: true });
    onParallaxScroll();
  }

  /* ---------- Product gallery thumbnails (click to swap main image) ---------- */
  var mainImage = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc) {
          mainImage.src = fullSrc;
        }
        thumbs.forEach(function (t) { t.removeAttribute('data-active'); });
        thumb.setAttribute('data-active', '');
      });
    });
  }
});
